import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../less/main.less";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router";
import { getJSON } from "./infrastructure/api/digipost-fetch";
import { EntrypointLoadError } from "./infrastructure/errors/errors";
import ErrorPage from "./ErrorPage/ErrorPage";
import { Entrypoint } from "./infrastructure/entrypoint/EntrypointContext";
import { LanguageProvider } from "./infrastructure/translation/LanguageContext";
import ScreenSizeContextProvider from "./infrastructure/screenSize/ScreenSizeContext";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { LoadingPage } from "./LoadingPage/LoadingPage";
import appRoutes from "./infrastructure/routing/AppRoutes";

const entrypointLoader = async (): Promise<Entrypoint> => {
  return getJSON<Entrypoint>("/api").catch((error) => {
    return Promise.reject(new EntrypointLoadError(error));
  });
};

const router = createBrowserRouter([
  {
    path: "/:language?",
    element: <App />,
    errorElement: <ErrorPage />,
    loader: entrypointLoader,
    children: appRoutes,
    hydrateFallbackElement: <LoadingPage />,
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LanguageProvider>
      <ScreenSizeContextProvider>
        <Header />
        <RouterProvider router={router} />
        <Footer />
      </ScreenSizeContextProvider>
    </LanguageProvider>
  </StrictMode>,
);
